// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../assets/images/descarga/bg-mobile.png", import.meta.url);
// Module
var code = `<section class="descarga"
    id="descarga">

    <div class="descarga__container container container--space">
        <div class="descarga__row row">

            <div class="descarga__col col-lg-6">

                <h2 class="descarga__title">
                    {{\$ctrl.descargaData.title}}
                </h2>

                <div class="descarga__description"
                    ng-bind-html="\$ctrl.descargaData.description">
                </div>

                <div class="descarga__stores">

                    <a class="descarga__store"
                        ng-repeat="store in \$ctrl.descargaData.stores track by \$index"
                        ng-href="{{store.link}}"
                        target="_blank"
                        rel="noopener">

                        <img class="descarga__store-img"
                            ng-src="{{store.image}}"
                            alt="{{store.alt}}">
                    </a>

                </div>

            </div>
        </div>

    </div>
    <img class="descarga__image d-lg-none"
        src="${___HTML_LOADER_IMPORT_0___}"
        alt="">

</section>`;
// Exports
export default code;